import { render, staticRenderFns } from "./CampaignStatsModal.vue?vue&type=template&id=ef5bc4aa&scoped=true&"
import script from "./CampaignStatsModal.vue?vue&type=script&lang=js&"
export * from "./CampaignStatsModal.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatsModal.vue?vue&type=style&index=0&id=ef5bc4aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5bc4aa",
  null
  
)

export default component.exports